module.exports = __webpack_public_path__ + "img/AUTO_PHOTO_ACTIVE.598ec48f.svg";